import { createFileRoute } from '@tanstack/react-router';
import AkomiLoginPage from 'src/AkomiLoginPage/AkomiLoginPage';
import { requireGuest } from 'src/utils/authGuard';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    requireGuest();
  },
  component: AkomiLoginPage,
});
